import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";
import { Gift, X } from "lucide-react";

export function PromoBanner() {
  const location = useLocation();
  const [promo, setPromo] = useState(null);
  const [closed, setClosed] = useState(() => (typeof window !== "undefined" && sessionStorage.getItem("ys_promo_closed") === "1"));

  useEffect(() => { api.get("/promo").then(({ data }) => setPromo(data)).catch(() => {}); }, []);

  if (closed || location.pathname === "/" || !promo?.active) return null;

  const end = promo.end ? new Date(promo.end) : null;
  const d = end ? Math.ceil((end.getTime() - Date.now()) / 86400000) : null;
  const countdown = d == null || d < 0 ? null : d === 0 ? "Ends today" : `Ends in ${d} day${d === 1 ? "" : "s"}`;

  return (
    <div data-testid="global-promo-banner"
      className="relative z-[1200] bg-gradient-to-r from-ys-gold to-amber-400 text-slate-900 px-10 py-2.5 text-center text-sm font-semibold flex items-center justify-center gap-2 flex-wrap">
      <Gift className="w-4 h-4 shrink-0" />
      <span>{promo.title || "Limited-time FREE access"} — {promo.message || "Browse, Sell & Buy on Yard-skip free while the promo lasts!"}</span>
      {countdown && <span className="inline-flex items-center rounded-full bg-slate-900 text-white text-xs font-bold px-2.5 py-0.5" data-testid="global-promo-countdown">{countdown}</span>}
      <button onClick={() => { sessionStorage.setItem("ys_promo_closed", "1"); setClosed(true); }} data-testid="promo-banner-close" aria-label="Close promo banner"
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 rounded-full hover:bg-black/10 active:bg-black/20 transition-colors"><X className="w-4 h-4" /></button>
    </div>
  );
}
